/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assetsListAssets } from "../funcs/assetsListAssets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAssetsResult } from "../models/components/listassetsresult.js";
import {
  ListAssetsRequest,
  ListAssetsSecurity,
} from "../models/operations/listassets.js";
import { unwrapAsync } from "../types/fp.js";
export type ListAssetsQueryData = ListAssetsResult;

export function prefetchListAssets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAssetsRequest | undefined,
  security?: ListAssetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListAssetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListAssetsQuery(
  client$: GramCore,
  request?: ListAssetsRequest | undefined,
  security?: ListAssetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListAssetsQueryData>;
} {
  return {
    queryKey: queryKeyListAssets({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
      gramKey: request?.gramKey,
    }),
    queryFn: async function listAssetsQueryFn(
      ctx,
    ): Promise<ListAssetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(assetsListAssets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListAssets(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "assets", "listAssets", parameters];
}
